/** Unleash 플래그 — ON 이면 운영자가 수동으로 점검 안내를 강제한다. */
export const MAINTENANCE_FLAG = 'viewup-maintenance';
